import React from 'react';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Type } from '@spotify-internal/encore-creator-web';
import { EmailUnsubscribeHeader, Content } from './';
import { Footer } from '../LandingPage/Footer';

export function UnsubscribeError() {
  let { subscriptionToken } = useParams();

  return (
    <>
      <EmailUnsubscribeHeader />
      <Content>
        <Type as="h1" variant={Type.heading2} weight={Type.bold}>
          Something went wrong.
        </Type>
        <Type as="p" variant={Type.body1}>
          Try <Link to={`/subscription/${subscriptionToken}/unsubscribe`}>unsubscribing again</Link>
          , or come back later.
        </Type>
      </Content>
      <Footer />
    </>
  );
}
